import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { UiHelpCircleIcon } from "@jti/brand-icons/ui-help-circle";
import styles from "./PasswordRequirementItem.module.scss";
export const PasswordRequirementItem = ({ isChecked, message, dataTestId }) => {
    const Icon = isChecked ? UiCheckIcon : UiHelpCircleIcon;
    return (_jsxs("div", { "data-testid": dataTestId, className: styles.container, children: [_jsx(Icon, { className: styles.icon }), _jsx("span", { className: styles.message, children: message })] }));
};
//# sourceMappingURL=PasswordRequirementItem.js.map